(function() {
  'use strict';

  // FAQ Accordion
  function avalnaInitFaq() {
    const faqItems = document.querySelectorAll('[data-avalna-faq-toggle]');
    if (!faqItems.length) return;

    faqItems.forEach(function(button) {
      button.addEventListener('click', function() {
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        const answerId = this.getAttribute('aria-controls');
        const answer = document.getElementById(answerId);
        if (!answer) return;

        // Close all other FAQ items (accordion behavior)
        const allButtons = document.querySelectorAll('[data-avalna-faq-toggle]');
        allButtons.forEach(function(otherButton) {
          if (otherButton !== button) {
            otherButton.setAttribute('aria-expanded', 'false');
            var otherAnswer = document.getElementById(otherButton.getAttribute('aria-controls'));
            if (otherAnswer) {
              otherAnswer.hidden = true;
            }
          }
        });

        // Toggle current item
        if (isExpanded) {
          this.setAttribute('aria-expanded', 'false');
          answer.hidden = true;
        } else {
          this.setAttribute('aria-expanded', 'true');
          answer.hidden = false;
        }
      });
    });
  }

  // Initialize on DOMContentLoaded and on Shopify section load (for theme editor)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avalnaInitFaq);
  } else {
    avalnaInitFaq();
  }

  // Re-init when sections are loaded in the theme editor
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('[data-avalna-faq-toggle]')) {
      avalnaInitFaq();
    }
  });
})();
